import React from 'react';
import { FadeInUp, SectionLabel, AccentLine } from './AnimationWrappers';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const PeoplePreview = () => {
  return (
    <section id="people-preview" data-testid="people-preview-section" className="relative overflow-hidden" style={{ background: '#FAF8F5', padding: '60px 0' }}>
      <div className="container-main">
        <SectionLabel number="10" title="People First" />
        <FadeInUp>
          <AccentLine />
          <h2 className="font-display mb-6" style={{ fontSize: 'clamp(1.8rem, 4vw, 2.4rem)', fontWeight: 700, color: '#1C1C1E' }}>
            Behind Every Stitch, a <span style={{ color: '#C8102E' }}>Person.</span>
          </h2>
        </FadeInUp>

        <FadeInUp delay={0.1}>
          <div className="overflow-hidden mb-8" style={{ borderRadius: '14px', background: '#1C1C1E' }}>
            <div className="grid grid-cols-1 md:grid-cols-2">
              <div className="flex flex-col justify-center" style={{ padding: 'clamp(1.5rem, 4vw, 2.5rem)' }}>
                <blockquote className="font-display text-white mb-4" style={{
                  fontSize: 'clamp(1rem, 2vw, 1.3rem)', fontWeight: 600, lineHeight: 1.4,
                  borderLeft: '3px solid #C8102E', paddingLeft: '16px',
                }}>
                  A worker who celebrates at the factory will take pride in what they build at the factory.
                </blockquote>
                <span className="font-mono" style={{ fontSize: '0.6rem', color: 'rgba(255,255,255,0.35)', letterSpacing: '0.2em', textTransform: 'uppercase' }}>
                  The Qualiance Philosophy
                </span>
              </div>
              <div className="relative overflow-hidden" style={{ minHeight: '220px' }}>
                <img src="/people-diwali.jpg" alt="Qualiance team celebrating Diwali" className="w-full h-full object-cover" />
              </div>
            </div>
          </div>
        </FadeInUp>

        <FadeInUp delay={0.2}>
          <Link
            to="/people"
            data-testid="people-view-more"
            className="inline-flex items-center gap-2 font-mono text-[0.75rem] tracking-[0.08em] uppercase px-6 py-3 rounded transition-all duration-300 hover:gap-4"
            style={{ background: '#1C1C1E', color: '#FFFFFF' }}
          >
            Explore Our People <ArrowRight size={14} />
          </Link>
        </FadeInUp>
      </div>
    </section>
  );
};

export default PeoplePreview;
